import React, { useState, useEffect } from "react";
import styles from "./Main.module.scss";
import CardInfo from "../CardInfo/CardInfo";
import Label from "../../../../components/Label/Label";
import Webcam from "../Webcam/Webcam";
import News from "../News/News";
import dashboardIcon1 from '../../../../img/dashboardIcon1.webp'
import dashboardIcon2 from '../../../../img/dashboardIcon2.webp'
import dashboardIcon3 from '../../../../img/dashboardIcon3.webp'
import TimerIcon from "../../../../img/timer.svg";
import ArchiveIcon from "../../../../img/archive.svg";
import { FRONT_URL } from "../../../../http";
import { useTranslation } from "react-i18next";
import moment from "moment";
import getRequest from "../../../../helpers/getRequest";
import Button from "../../../../components/Button/Button";
import Cross from "../../../../img/IconComponents/Cross";
import copyIcon from "../../../../img/copy.svg";
import cn from "classnames";
import token from "../../../../img/tokenNew.webp";

const Main = ({ currentLang }) => {
  const [plantsBalance, setPlantBalance] = useState("0");
  const [harvestBalance, setHarvestBalance] = useState("0");
  const [euroBalance, setEuroBalance] = useState("0");
  const [timer, setTimer] = useState("07-01-2024");
  const [totalHarvest, setTotalHarvest] = useState("0");
  const [mlmLink, setMlmLink] = useState("");
  const [id, setId] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [plants, setPlants] = useState([]);
  const [clientName, setClientName] = useState("");

  //check if user has calculator visible
  useEffect(() => {
    getRequest("v1/auth/whoami")
      .then((res) => {
        if(res.data.isCalculatorShown === true){
          localStorage.setItem('isCalcShown', true)
        } else{
          localStorage.removeItem('isCalcShown')
        }
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    getRequest("v1/dashboard/balance").then((response) => {
      setPlantBalance(response?.data?.plantsBalance);
      setHarvestBalance(response?.data?.harvestBalance);
      setEuroBalance(response?.data?.euroBalance);
    });

    getRequest("v1/dashboard/harvest").then((response) => {
      // setTimer(response?.data?.nearestHarvestDate);
      setTotalHarvest(response?.data?.totalHarvest);
    });

    getRequest("v1/finances/data")
      .then((response) => {
        setPlants(response.data.plantsDetails);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const countdownHours = moment(timer).diff(moment(), "hours");
  const countdownDays = Math.floor(countdownHours / 24);
  const { t } = useTranslation();

  useEffect(() => {
    getRequest("v1/referrals/my-mlm")
      .then((response) => setMlmLink(response.data?.mlm_link))
      .catch((error) => console.log(error));

    getRequest("v1/auth/whoami")
      .then((res) => {
        setClientName(res.data?.first_name + " " + res.data?.last_name);
        setId(res.data?.id);
      })
      .catch((err) => console.log(err));
  }, []);

  const copyToClipboard = () => {
    const url = `${FRONT_URL}/register/ref/${id}`;
    navigator.clipboard.writeText(url);
    setIsCopied(true);
    const timer = setTimeout(() => {
      setIsCopied(false);
    }, [2000]);

    return () => {
      clearTimeout(timer);
    };
  };

  const copyAndClose = () => {
    copyToClipboard();
    const timer = setTimeout(() => {
      setOpenModal(false);
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  };

  return (
    <section className={styles.dashboard}>
      <h3 style={{ paddingInline: "10px", marginBottom: '10px' }} className={styles.mobile}>
        {t("Welcome,")} {clientName}
      </h3>
      {plants.length == 0 && (
        <div className={styles.dashboard__empty}>
          <div className={styles.dashboard__empty_left}>
            <img src={token} alt="empty" />
            <Button text={t("Buy Now")} color="green" to="/buy" />
          </div>
          <div className={styles.dashboard__empty_right}>
            <h5>{t("1 Planting site NFT:")}</h5>
            <div className={styles.dashboard__empty_right_inner}>
              <div>
                <p>
                  <span>{t("Annual harvest yield:")}</span>
                  <span>200g</span>
                </p>
                <p>{t("Lifetime term")}</p>
              </div>
              <div>
                <p>
                  <span className={styles.desktop}>{t("Planned cultivation start:")}</span>
                  <span className={styles.mobile}>{t("Сultivation start:")}</span>
                  <span>01.07.2024</span>
                </p>
                <p>
                  <span>{t("Cultivation site:")}</span>
                  <span>{t("Mecklenburg Vorpommern")}</span>
                </p>
                <p>
                  <span>{t("First harvest:")}</span>
                  <span>{t("Announcement after cultivation start")}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className={styles.dashboard__header}>
        <CardInfo
          title={t("My tokens")}
          value={plantsBalance || 0}
          dimension={t("tokens")}
          image={dashboardIcon1}
          action={{ text: t("Buy more"), path: "/buy" }}
        />
        <CardInfo
          title={t("My harvest")}
          value={harvestBalance || 0}
          dimension="g"
          image={dashboardIcon2}
        />
        <CardInfo
          title={t("My result")}
          value={euroBalance || 0}
          dimension="EUR"
          image={dashboardIcon3}
        />
      </div>
      {mlmLink && (
        <div className={styles.dashboard__dect}>
          <p>{t("Sell DECT-Tokens now and generate passive income")}</p>
          <Button
            to={mlmLink}
            text="To DECT Distribution Website"
            color="green"
            blank
          />
        </div>
      )}
      <div className={`${styles.dashboard__referral} ${styles.desktop}`}>
        <p>{t("Invite friends and earn 5% commission!")}</p>
        <Button
          text="Invite Now"
          color="referral"
          onClick={() => setOpenModal(true)}
        />
      </div>
      <div className={styles.dashboard__subheader}>
        <Label
          icon={TimerIcon}
          label={t("Countdown to the start of cultivation (expected)")}
          value={
            timer
              ? `${countdownDays} ${t("d")} ${
                  countdownHours - countdownDays * 24
                } ${t("h")}`
              : "—"
          }
        />
        <Label
          icon={ArchiveIcon}
          label={t("Total harvest")}
          // value="1,249 kg 549g"
          value={`${totalHarvest} g`}
        />
      </div>
      <div className={styles.newsWebcam}>
      <Webcam />
      <News currentLang={currentLang} />
      </div>
      <div className={`${styles.dashboard__referral} ${styles.mobile}`}>
        <p>{t("Invite friends and receive 0.05 DECT worth €125.")}</p>
        <Button
          text="Invite Now"
          color="referral"
          onClick={() => setOpenModal(true)}
        />
      </div>
      {openModal ? (
        <div className={styles.modal}>
          <div className={styles.modal__inner}>
            <button
              className={styles.modal__inner_close}
              onClick={() => setOpenModal(false)}
            >
              <Cross />
            </button>
            <div className={styles.modal__inner_title}>
              {t("Your referral")}
            </div>
            <div className={styles.modal__inner_wrapper}>
              <div
                className={styles.modal__inner_code}
              >{`${FRONT_URL}/register/ref/${id}`}</div>
              <button
                className={styles.modal__copy}
                onClick={() => copyToClipboard()}
              >
                <img src={copyIcon} alt="copy" />
              </button>
            </div>
            <div className={styles.modal__copy_container}>
              <div
                className={cn(
                  styles.modal__copy_state,
                  isCopied ? styles.modal__copy_state_active : ""
                )}
              >
                {t("Copied to clipboard")}
              </div>
            </div>
            <div className={styles.modal__btn} onClick={copyAndClose}>
              {t("Copy referral link and close window")}
            </div>
          </div>
        </div>
      ) : null}
    </section>
  );
};

export default Main;
